export const messages = {
  en: {
    demo: {
      addDemo: 'Add Demo',
      demoName: 'Demo Name',
      demoValue: 'Demo Value',
      demoRemark: 'Remark',
      requiredDemoName: 'Required, please enter demo name',
      requiredDemoValue: 'Required, please enter demo value',
      optionalDemoRemark: 'Optional, please enter remark',
      demoNameLength: 'Length should be between 2 to 20 characters',
      demoValueLength: 'Length should be between 2 to 20 characters',
      demoRemarkMaxLength: 'Remark cannot exceed 200 characters',
      save: 'Save',
      cancel: 'Cancel',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Save failed'
    }
  },
  zh: {
    demo: {
      addDemo: '添加用例',
      demoName: '用例名称',
      demoValue: '用例值',
      demoRemark: '备注',
      requiredDemoName: '必填，请填写用例名称',
      requiredDemoValue: '必填，请填写用例值',
      optionalDemoRemark: '可填，请填写备注',
      demoNameLength: '名称长度必须在2位至20位',
      demoValueLength: '值长度必须在2位至20位',
      demoRemarkMaxLength: '备注长度不能超过200位',
      save: '保存',
      cancel: '取消',
      saveSuccess: '保存成功',
      saveFailed: '保存失败'
    }
  }
}